import React from 'react';
import { motion } from 'framer-motion';
import PageHeader from './PageHeader';

const GOOGLE_MAPS = 'https://maps.app.goo.gl/NT8DLWpx1zcxeDuT9?g_st=ic';
const APPLE_MAPS = 'https://maps.apple/p/vcdtRNhJeZ0vIT';

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function openNavigation() {
  window.open(isIOS() ? APPLE_MAPS : GOOGLE_MAPS, '_blank');
}

export default function Location({ onBack }) {
  return (
    <div className="flex flex-col items-center px-6 pt-14 pb-8 max-w-md mx-auto">
      <PageHeader title="Mekan & Yol Tarifi" onBack={onBack} />

      <div className="mt-4 w-full">
        {/* Google Maps embed */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full rounded-3xl overflow-hidden border border-gold-300/40 shadow-lg shadow-sage-200/20 mb-4"
        >
          <iframe
            title="Moira Concept Harita"
            src="https://maps.google.com/maps?q=Moira+Concept+%C4%B0ncek+G%C3%B6lba%C5%9F%C4%B1+Ankara&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="220"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full"
          />
        </motion.div>

        {/* Mekan kartı */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="w-full bg-white/80 backdrop-blur-sm rounded-3xl border border-gold-300/40 p-8 shadow-lg shadow-sage-200/20"
        >
          {/* Tarih & Saat */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-sage-50 rounded-full mb-4">
              <span className="text-sage-600 text-xs font-medium">17 Mayıs 2026</span>
              <span className="w-1 h-1 bg-gold-500 rounded-full" />
              <span className="text-sage-600 text-xs font-medium">15:00 — 18:00</span>
            </div>
          </div>

          {/* Mekan adı ve adres */}
          <div className="text-center mb-5">
            <h3 className="font-playfair text-lg text-sage-800 font-semibold">Moira Concept</h3>
            <p className="text-sage-500 text-sm mt-2 leading-relaxed">
              Türkan Şoray Caddesi Kapı No:25,<br />
              İncek, Gölbaşı/Ankara
            </p>
          </div>

          {/* Altın ayraç */}
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-px bg-gold-300" />
            <span className="text-gold-400 text-xs">✦</span>
            <div className="w-12 h-px bg-gold-300" />
          </div>

          {/* Ana navigasyon butonu */}
          <button
            onClick={openNavigation}
            className="w-full py-4 bg-sage-600 hover:bg-sage-700 text-white rounded-2xl font-medium
                       transition-all active:scale-[0.98] flex items-center justify-center gap-3
                       shadow-lg shadow-sage-300/30"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
            </svg>
            Yol Tarifi Al
          </button>

          {/* Manuel linkler */}
          <div className="flex items-center justify-center gap-4 mt-4">
            <a
              href={GOOGLE_MAPS}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sage-400 hover:text-sage-600 text-xs underline underline-offset-2 transition-colors"
            >
              Google Maps
            </a>
            <span className="text-sage-300 text-xs">|</span>
            <a
              href={APPLE_MAPS}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sage-400 hover:text-sage-600 text-xs underline underline-offset-2 transition-colors"
            >
              Apple Maps
            </a>
          </div>
        </motion.div>

        {/* Bilgi notu */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-6 text-sage-400 text-xs text-center leading-relaxed"
        >
          Butona bastığınızda cihazınıza uygun harita<br />uygulaması otomatik olarak açılacaktır.
        </motion.p>
      </div>
    </div>
  );
}
